<template>
  <NodePressRelease v-if="node" v-bind="node" />
</template>

<script lang="ts" setup>
import type { NodePressReleaseFragment } from '#graphql-operations'

defineOptions({
  name: 'PagePressReleaseSlug',
})

definePageMeta({
  name: 'press-release-detail',
  languageMapping: {
    de: '/de/medien/:slug(.*)*',
    fr: '/fr/communiques-de-presse/:slug(.*)*',
    en: '/en/press-release/:slug(.*)*',
  },
})

const nuxtRoute = useRoute()

const { data: query } = await useAsyncData(nuxtRoute.path, async () => {
  return await useGraphqlQuery('routeNodePressRelease', {
    path: nuxtRoute.path,
  }).then((v) => {
    return v.data
  })
})

const { entity: node } = await useDrupalRoute<NodePressReleaseFragment>(
  query.value,
)

setBreadcrumbLinksFromRoute(query.value)
setBusinessAreaFromRoute(query.value)
setLanguageLinksFromRoute(query.value)
await renderPageDependencies()
</script>
